import React from 'react';
import styled from 'styled-components';
import {
  IndicatorByService,
  IndicatorHeaderList,
  isIndicatorListValid,
} from './utils';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';

interface ImpactHeadersProps {
  list: IndicatorHeaderList[];
  selectedText?: IndicatorHeaderList;
  selectedIndicators: IndicatorByService;
  capacityDevelopmentEnabled: boolean;
  learnEnabled: boolean;
  actEnabled: boolean;
  onClick?: (text: IndicatorHeaderList, index: number) => unknown;
}

const getText = (text: IndicatorHeaderList['text']) => {
  switch (text) {
    case 'capacity development':
      return 'Program Development';
    case 'act':
      return 'Act';
    case 'catalyzed':
      return 'Catalyzed';
    case 'learn':
      return 'Learn';
    case 'reach':
      return 'Reach';
    case 'succeed':
      return 'Succeed';
    default:
      return text;
  }
};

const StyledDiv = styled.div`
  padding-bottom: ${SPACERS.medium};
  margin-bottom: ${SPACERS.large};
  border-bottom: 1px solid ${COLORS.grayLight};
  display: flex;
  align-item: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: ${SPACERS.medium};
  .stage {
    cursor: pointer;
    display: flex;
    align-item: center;
    justify-content: center;
    flex-direction: column;
    .stage-bar {
      position: relative;
      width: 142px;
      height: 8px;
      border-radius: 47px;
      margin-bottom: ${SPACERS.tiny};
      background: ${COLORS.grayLight};
      .inprogress,
      .incomplete,
      .completed {
        height: 100%;
        background: ${COLORS.success};
        border-radius: 47px;
        position: absolute;
        left: 0;
        top: 0;
      }
      .selected {
        background: ${COLORS.ctaPrimary};
      }
      .incomplete {
        width: 0%;
      }
      .selected.incomplete {
        width: 50%;
      }
      .completed {
        width: 100%;
      }
    }
  }
`;

const ImpactHeaders: React.FC<ImpactHeadersProps> = ({
  list,
  selectedText,
  selectedIndicators,
  capacityDevelopmentEnabled,
  learnEnabled,
  actEnabled,
  onClick,
}) => {
  return (
    <StyledDiv>
      {list.map((l, i) => {
        const selected = l.text === selectedText?.text;
        const validation = isIndicatorListValid(
          selectedIndicators[l.sectionKey],
          capacityDevelopmentEnabled,
          learnEnabled,
          actEnabled,
          l.sectionKey,
        );
        const completed =
          selectedIndicators[l.sectionKey].length > 0 &&
          validation.isValid &&
          validation.isAnySeen;
        return (
          <div
            key={l.text}
            className="stage"
            onClick={selected || !onClick ? undefined : () => onClick(l, i)}
          >
            <div className="stage-bar">
              <div
                className={
                  selected && completed
                    ? 'selected completed'
                    : selected
                    ? 'selected incomplete'
                    : completed
                    ? 'completed'
                    : 'incomplete'
                }
              />
            </div>
            <TrueImpactText variant="body-small-bold">
              {getText(l.text)}
            </TrueImpactText>
          </div>
        );
      })}
    </StyledDiv>
  );
};

export default ImpactHeaders;
